module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-4-4.8f07a7a2.png";